// Helpers
import {
  formatEventDateTime,
  getCardLabel,
  getTicketsLabel,
  getTicketSerials,
  OrderRow,
} from 'pages/Events/helpers';

/** One CSV line per order, with dates in the event's time zone. */
export const toOrdersCsvRows = (
  rows: OrderRow[],
  timezone: string
): Record<string, string | number>[] =>
  rows.map((row) => ({
    reference: row.reference,
    kind: row.kind,
    status: row.status,
    customer: row.customerName || '',
    email: row.email || '',
    tickets: getTicketsLabel(row),
    admissions: row.admissionCount,
    paid: row.amount,
    discount: row.discountAmount,
    serviceFee: row.serviceFeeAmount,
    promoCode: row.promocodeCode || '',
    presaleCode: row.presaleCode || '',
    card: getCardLabel(row),
    serials: getTicketSerials(row).join(' '),
    created: formatEventDateTime(row.createdAt, timezone),
    refundRequested: row.refundRequestedAt
      ? formatEventDateTime(row.refundRequestedAt, timezone)
      : '',
    refundRequestedBy: row.refundRequestedBy?.name || '',
    refunded: row.refundedAt
      ? formatEventDateTime(row.refundedAt, timezone)
      : '',
    refundFailure: row.refundFailure?.reason || '',
    note: row.note || '',
  }));
